const PATH_DELIMITER = '/';
const POLL_STATUS_DELAY_MS = 1000;
const QUEUED_CODE_RANGE = [100, 200];
const PROCESSING_CODE_RANGE = [200, 300];
const RETRYABLE_ERROR_CODE_RANGE = [300, 400];
const RECOVERABLE_ERROR_CODE_RANGE = [400, 500];
const RETRY_SEARCH_ERROR_CODE_RANGE = [500, 600];
const UNKNOWN_ERROR_CODE_RANGE = [600, 700];

const CONTACT_INFO_SECTION_ID = 'contactInfoSection';
const CONTACT_INFO_SECTION_PATH = ['generalForm', CONTACT_INFO_SECTION_ID];
const BILLING_ADDRESS_SECTION_PATH = ['generalForm', 'billingSection', 'billingAddressSection'];
const BILLING_SECTION_ID = 'billingAddressSection';
const PASSENGER_SECTION_ID = 'passengersSection';
const PRIMARY_PASSENGER_SECTION_PATH = ['generalForm', PASSENGER_SECTION_ID, 'primaryPassengerSection'];
const FIRST_NAME_FIELD_ID = 'firstName';
const LAST_NAME_FIELD_ID = 'lastName';
const USER_EMAIL_FIELD_ID = 'email';
const STREET_ADDRESS_ID = 'streetAddress';
const SECONDARY_STREET_ADDRESS_ID = 'streetAddress2'; // tix provided id for the secondary address line
const TERMS_CONTAINER_ID = 'footNotes';
const TERMS_INPUT_FIELD_ID = 'termsAndConditionsCheckbox';
const TERMS_DESCRIPTION_FIELD_ID = 'termsAndConditionsForCheckbox';
const USER_ACCOUNT_FIELD_IDS = { /* eslint-disable sort-keys */
    email: [...CONTACT_INFO_SECTION_PATH, USER_EMAIL_FIELD_ID].join(PATH_DELIMITER),
    primaryPassengerFirstName: [...PRIMARY_PASSENGER_SECTION_PATH, 'primaryPassengerSection.primaryPassengerFirstName'].join(PATH_DELIMITER),
    primaryPassengerLastName: [...PRIMARY_PASSENGER_SECTION_PATH, 'primaryPassengerSection.primaryPassengerLastName'].join(PATH_DELIMITER),
    firstName: [...BILLING_ADDRESS_SECTION_PATH, FIRST_NAME_FIELD_ID].join(PATH_DELIMITER),
    lastName: [...BILLING_ADDRESS_SECTION_PATH, LAST_NAME_FIELD_ID].join(PATH_DELIMITER),
    phoneNumber: [...CONTACT_INFO_SECTION_PATH, 'phoneNumber'].join(PATH_DELIMITER),
    streetAddress: [...BILLING_ADDRESS_SECTION_PATH, STREET_ADDRESS_ID].join(PATH_DELIMITER),
    streetAddress2: [...BILLING_ADDRESS_SECTION_PATH, SECONDARY_STREET_ADDRESS_ID].join(PATH_DELIMITER),
    country: [...BILLING_ADDRESS_SECTION_PATH, 'country'].join(PATH_DELIMITER),
    stateProvince: [...BILLING_ADDRESS_SECTION_PATH, 'stateProvince'].join(PATH_DELIMITER),
    city: [...BILLING_ADDRESS_SECTION_PATH, 'city'].join(PATH_DELIMITER),
    postalCode: [...BILLING_ADDRESS_SECTION_PATH, 'postalCode'].join(PATH_DELIMITER),
}; /* eslint-enable sort-keys */
const CREDIT_CARD_SECTION_FIELDS = ['cardType', 'cardNumber', 'cvv', 'expiryMonth', 'expiryYear'];
const CREDIT_CARD_SECTION = 'creditCardSection';
const DANGEROUSLY_SET_FIELD_IDS = ['travelInsuranceDisclaimer', 'termsAndConditions'];
const HEADER_OFFSET = 2;
const EXT_SEARCH_DELIM = ';';
const EXT_SEARCH_DIRECTION_DELIM = '||';
const EXT_SEARCH_TRIP_DELIM = '|';
const AMERICAN_SAMOA = 'AS';
const GUAM = 'GU';
const NORTHERN_MARIANA_ISLANDS = 'MP';
const PUERTO_RICO = 'PR';
const US_MINOR_OUTLYING_ISLANDS = 'UM';
const VIRGIN_ISLANDS = 'VI';
const US_NON_STATE_TERRITORIES = [
    AMERICAN_SAMOA,
    GUAM,
    NORTHERN_MARIANA_ISLANDS,
    PUERTO_RICO,
    US_MINOR_OUTLYING_ISLANDS,
    VIRGIN_ISLANDS,
];
const USER_INFO_FIELD_NAME_MAP = { /* eslint-disable sort-keys */
    email: 'email',
    firstName: 'firstName',
    lastName: 'lastName',
    primaryPassengerFirstName: 'firstName',
    primaryPassengerLastName: 'lastName',
    phoneNumber: 'phone',
    streetAddress: 'street',
    streetAddress2: 'street2',
    stateProvince: 'stateProvince',
    country: 'country',
    city: 'city',
    postalCode: 'postalCode',
};/* eslint-enable sort-keys */
const NO_BLUR_EVENT_FIELDS = [
    'boolean',
    'country',
    'multiplechoice',
    'select',
    'state',
    'encryptedcard',
];
const SELF_CONTROLLED_FIELDS = [
    'creditcard',
];
const SLIMMED_PROPERTIES = ['id', 'value', 'meta', 'formVersion'];
const TRIP_LEG_ITEMS_FROM_QUOTE_DATA = {
    fees: 'lineItems',
    notices: 'notices',
    promos: 'promos',
};
const EMAIL_FIELD_ID = 'email';
const READ_ONLY_FIELDS = ['richtextcontent', 'plaintextcontent'];
const CHECKOUT_URL_SEGMENT = 'checkout';
const ACCOUNT_PASSWORD_ID = 'accountPassword';
const INSURANCE_SECTION = 'insuranceGroup';
const INSURANCE_SELECTED_VALUE = 'Purchase';
const INSURANCE_SELECTION_ID = 'travelInsuranceSelection';
const SPECIAL_NEEDS_SECTION_ID_PARTIAL = 'SpecialNeedsSection';
const BORDER_DOCUMENTATION_SECTION_ID_PARTIAL = 'PassengerBorderDocumentSection';
const AUTOCOMPLETE_MAP = {
    cardNumber: 'cc-number',
    citizenship: 'country-name',
    city: 'address-level2',
    country: 'country',
    cvv: 'cc-csc',
    dateOfBirth: 'bday',
    email: 'email',
    expiryMonth: 'cc-exp-month',
    expiryYear: 'cc-exp-year',
    firstName: 'given-name',
    gender: 'sex',
    lastName: 'family-name',
    phoneNumber: 'tel',
    postalCode: 'postal-code',
    stateProvince: 'address-level1',
    streetAddress: 'address-line1',
    streetAddress2: 'address-line2',
};
const MARKETING_OPT_IN_FIELD_ID = 'exclusiveTravelDeals';
const BROWSER_LIST = [
    { identity: 'Chrome', subString: 'Chrome' },
    { identity: 'Explorer', subString: 'MSIE' },
    { identity: 'Explorer', subString: 'Trident' },
    { identity: 'Firefox', subString: 'Firefox' },
    { identity: 'Safari', subString: 'Safari' },
    { identity: 'Opera', subString: 'Opera' },
];

const LIVE_CHECK_TRIP_NOT_FOUND_ERRORS = [
    'TRIPS_NOT_FOUND',
    'LIVE_CHECK_TRIP_NOT_FOUND',
    'INVALID_LIVE_SERVICE_QUERY_EXPIRED_TRIP',
    1300, // sold out
];

const LIVE_CHECK_CACHE_EXPIRED_ERROR = 'CACHED_LIVE_CHECK_TRIP_NOT_FOUND';

export {
    ACCOUNT_PASSWORD_ID,
    AUTOCOMPLETE_MAP,
    BILLING_SECTION_ID,
    BORDER_DOCUMENTATION_SECTION_ID_PARTIAL,
    BROWSER_LIST,
    CHECKOUT_URL_SEGMENT,
    CONTACT_INFO_SECTION_ID,
    CREDIT_CARD_SECTION,
    CREDIT_CARD_SECTION_FIELDS,
    DANGEROUSLY_SET_FIELD_IDS,
    EMAIL_FIELD_ID,
    EXT_SEARCH_DELIM,
    EXT_SEARCH_DIRECTION_DELIM,
    EXT_SEARCH_TRIP_DELIM,
    FIRST_NAME_FIELD_ID,
    HEADER_OFFSET,
    INSURANCE_SECTION,
    INSURANCE_SELECTED_VALUE,
    INSURANCE_SELECTION_ID,
    LAST_NAME_FIELD_ID,
    LIVE_CHECK_CACHE_EXPIRED_ERROR,
    LIVE_CHECK_TRIP_NOT_FOUND_ERRORS,
    MARKETING_OPT_IN_FIELD_ID,
    NO_BLUR_EVENT_FIELDS,
    PASSENGER_SECTION_ID,
    PATH_DELIMITER,
    POLL_STATUS_DELAY_MS,
    PROCESSING_CODE_RANGE,
    QUEUED_CODE_RANGE,
    READ_ONLY_FIELDS,
    RECOVERABLE_ERROR_CODE_RANGE,
    RETRYABLE_ERROR_CODE_RANGE,
    RETRY_SEARCH_ERROR_CODE_RANGE,
    SECONDARY_STREET_ADDRESS_ID,
    SELF_CONTROLLED_FIELDS,
    SLIMMED_PROPERTIES,
    SPECIAL_NEEDS_SECTION_ID_PARTIAL,
    STREET_ADDRESS_ID,
    TERMS_CONTAINER_ID,
    TERMS_DESCRIPTION_FIELD_ID,
    TERMS_INPUT_FIELD_ID,
    TRIP_LEG_ITEMS_FROM_QUOTE_DATA,
    UNKNOWN_ERROR_CODE_RANGE,
    USER_ACCOUNT_FIELD_IDS,
    USER_EMAIL_FIELD_ID,
    USER_INFO_FIELD_NAME_MAP,
    US_NON_STATE_TERRITORIES,
};
